import { ArrowRight } from 'lucide-react';

import { SectionWrapper } from '../components/SectionWrapper';

import examPerformanceUrl from '@/images/ai_exam_performance.png';
import styles from './ValidationResearchSection.module.css';

export function ValidationResearchSection() {
  return (
    <SectionWrapper background="white" data-testid="ai-section-validation">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>INDEPENDENT RESEARCH</p>
          <h2 className={styles.title}>
            KAI doesn&apos;t just feel helpful. It&apos;s been measured to be.
          </h2>
          <p className={styles.body}>
            Researchers at UCLA and UC San Diego studied AI-generated hints
            delivered through Kudu in an introductory physics course. The
            result: AI-generated hints were associated with improved exam
            performance, especially for students who need help most.
          </p>
          {/* From the paper's abstract. */}
          <figure className={styles.quote}>
            <blockquote>
              &quot;Our findings indicate that both these interventions are
              associated with increased exam scores.&quot;
            </blockquote>
            <figcaption>Lu et al. (2025)</figcaption>
          </figure>
          <div className={styles.meta}>
            <span>Published in Physical Review Physics Education Research (2025)</span>
            <span>
              Researchers: UCLA Center for Education Innovation and Learning in
              the Sciences (CEILS), in partnership with UC San Diego.
            </span>
          </div>
          <a className={styles.link} href="/research">
            Read the full study <ArrowRight aria-hidden="true" size={14} />
          </a>
        </div>

        <img
          alt="Figure 6 from Lu et al. (2025): exam 2 score against Force Concept Inventory score. Students who used AI hints scored higher, most of all those with the lowest inventory scores; the two lines meet near the top."
          className={styles.chart}
          loading="lazy"
          src={examPerformanceUrl}
        />
      </div>
    </SectionWrapper>
  );
}
